import * as _4 from 'lodash4';
import { RegisterSectionsQuery } from '../../course_scheduler/queries/register_sections_query';
import { TermCourseServant } from '../../term_courses/servants/term_course_servant';
import { ISection, ISectionType, ITermCourse } from '../../../interfaces/scheduler_interfaces';
import { MultiSectionServant } from '../../course_scheduler/servants/multi_section_servant';
import { ScheduledSectionStatusServant } from '../../course_scheduler/servants/scheduled_section_status_servant';
import { TermScheduleFlags } from '../../course_scheduler/services/term_schedule_flags';

export class RegistrationSectionFacade {
  constructor(
    private ngRegisterSectionsQuery: RegisterSectionsQuery,
    private ngMultiSectionServant: MultiSectionServant,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngTermScheduleFlags: TermScheduleFlags
  ) {}

  getUnscheduledOptionalSectionTypes() {
    const coursesScheduled = _4(this.ngRegisterSectionsQuery.result.selectedSections)
      .map((section) => section['_course'])
      .filter(TermCourseServant.isMultiSectionCourse)
      .uniqBy('id')
      .value();
    const courseIdsWithSessions = this.selectedCourseIdsWithSessions();
    const unScheduledOptionalSectionTypes = _4.flatMap(coursesScheduled, (course) =>
      this.getUnscheduledSectionTypeTemplate(courseIdsWithSessions, course)
    );
    return _4.uniq(_4.compact(unScheduledOptionalSectionTypes));
  }

  private selectedCourseIdsWithSessions() {
    const courseIdsWithSessions: Record<ITermCourse['id'], NonNullable<ISectionType['session']>> = {};
    const coursesScheduledById = _4.groupBy(this.ngRegisterSectionsQuery.result.selectedSections, '_course.id');
    _4.each(
      coursesScheduledById,
      (sections, courseId) =>
        (courseIdsWithSessions[courseId!] = _4.map(sections, (section) => _4.get(section, '_section_type.session')))
    );
    return courseIdsWithSessions;
  }

  private getUnscheduledSectionTypeTemplate(
    courseIdsWithSessions: Record<ITermCourse['id'], NonNullable<ISectionType['session']>>,
    course: ITermCourse
  ) {
    const optionalSectionTypes = this.ngMultiSectionServant.getUnscheduledOptionalSiblingSectionTypes(
      course,
      courseIdsWithSessions
    );
    return optionalSectionTypes.map(
      (sectionType) => `<strong class="font-bold>">${course.cd}</strong> ${course.title} ${sectionType.name}`
    );
  }

  isAnyScheduledUnselectedSectionsExist() {
    return !_4.isEmpty(this.getUnselectedScheduledNonWaitlistedSections());
  }

  getUnselectedScheduledNonWaitlistedSections() {
    return _4.filter(
      this.ngRegisterSectionsQuery.result.unselectedSections,
      (section: ISection) =>
        !this.ngScheduledSectionStatusServant.isStatusWaitlisted(section) && section._isEligibleForRegistration
    );
  }

  hasAnyScheduledSectionMissingRequirementsExist() {
    if (!this.ngTermScheduleFlags.isRequisiteReminderEnabled()) {
      return false;
    }
    const reqMissing = this.ngRegisterSectionsQuery.result;
    return !_4.isEmpty(reqMissing.coReqMissingSections) || !_4.isEmpty(reqMissing.preReqMissingSections);
  }
}
angular.module('capability-ng-scheduler').service('ngRegistrationSectionFacade', RegistrationSectionFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/facades/registration_section_facade.ts